// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --fuel-primary-color: #2563eb;
  --fuel-secondary-color: #1e40af;
  --fuel-background-light: #f9fafb;
  --fuel-text-primary: #1f2937;
  --fuel-text-secondary: #4b5563;
  --fuel-border-color: #e5e7eb;
}

body {
  margin: 0;
  font-family: sans-serif;
  background-color: var(--fuel-background-light);
  color: var(--fuel-text-primary);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.fuel-container {
  /* padding: 2.5rem;
  min-height: 100vh; */
  display: flex;
  justify-content: center;
  align-items: center;
}

.fuel-card {
  /* max-width: 90rem; */
  width: 100%;
  /* background-color: #fff; */
  /* box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1),
    0 4px 6px -2px rgba(0, 0, 0, 0.05); */
  /* border-radius: 1rem; */
  overflow: hidden;
}

.fuel-header {
  position: relative;
  /* background: var(--land-gradient-purple); */
  background: linear-gradient(135deg, #20948b 100%, #c4dfe6 0%);
  color: white;
  padding: 1rem 1rem;
  overflow: hidden;
  margin-bottom: 1.5rem;
  border-radius: 0 0 0rem 0rem;
  box-shadow: var(--land-shadow-lg);
}

.fuel-header-bg {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
}

.fuel-animated-shape {
  position: absolute;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
  animation: landFloat 6s ease-in-out infinite;
}

.fuel-shape-1 {
  width: 100px;
  height: 100px;
  top: 20%;
  left: 10%;
  animation-delay: 0s;
}

.fuel-shape-2 {
  width: 150px;
  height: 150px;
  top: 60%;
  right: 15%;
  animation-delay: 2s;
}

.fuel-shape-3 {
  width: 80px;
  height: 80px;
  bottom: 30%;
  left: 20%;
  animation-delay: 4s;
}

.fuel-shape-4 {
  width: 120px;
  height: 120px;
  top: 10%;
  right: 30%;
  animation-delay: 1s;
}

@keyframes landFloat {
  0%,
  100% {
    transform: translateY(0px) rotate(0deg);
  }
  50% {
    transform: translateY(-20px) rotate(180deg);
  }
}

.fuel-header-content {
  max-width: 800px;
  margin: 0 auto;
  text-align: center;
}

.fuel-title {
  /* font-size: 2rem;
  font-weight: 700;
  margin-bottom: 0.5rem; */
  font-size: 1.5rem;
  font-weight: 700;
  margin-bottom: 0.5rem;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  text-align: center;
}

.fuel-subtitle {
  font-size: 1.125rem;
  opacity: 0.9;
  font-weight: 300;
}

/* .fuel-header {
  color: #000000;
  border-radius: 1rem 1rem 0 0;
} */

/* .fuel-heading {
  font-size: 2rem;
  font-weight: 800;
  text-align: center;
  margin-bottom: 0.25rem;
}

.fuel-description {
  text-align: center;
  font-size: 1rem;
  font-weight: 300;
  opacity: 0.9;
} */

.fuel-content {
  padding: 2rem;
}

.fuel-select-wrapper {
  margin-bottom: 2rem;
  max-width: 24rem;
  /* margin-left: auto; */
  margin-right: auto;
}

.fuel-label {
  display: block;
  font-size: 0.875rem;
  font-weight: 500;
  color: var(--fuel-text-secondary);
  margin-bottom: 0.5rem;
}

.fuel-custom-select {
  position: relative;
}

.fuel-select {
  display: block;
  width: 100%;
  appearance: none;
  background-color: #fff;
  border: 1px solid var(--fuel-border-color);
  border-radius: 0.5rem;
  padding: 0.5rem 1rem;
  padding-right: 2rem;
  font-size: 1rem;
  color: var(--fuel-text-primary);
  outline: none;
  transition: all 0.2s ease-in-out;
}

.fuel-select:focus {
  /* border-color: var(--fuel-primary-color); */
  border-color: rgb(196, 223, 230);
  box-shadow: 0 0 0 2px rgb(196, 223, 230);
}

.fuel-loading,
.fuel-no-data {
  text-align: center;
  padding: 2.5rem 0;
  color: var(--fuel-text-secondary);
  font-size: 1rem;
}

.fuel-table-responsive {
  overflow-x: auto;
  border-radius: 0.5rem;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  border: 1px solid var(--fuel-border-color);
}

.fuel-table {
  width: 100%;
  text-align: left;
  white-space: nowrap;
  border-collapse: collapse;
}

.fuel-table thead {
  background-color: var(--fuel-background-light);
  border-bottom: 1px solid var(--fuel-border-color);
}

.fuel-table th {
  padding: 0.75rem 1.5rem;
  color: var(--fuel-text-secondary);
  text-transform: uppercase;
  font-size: 0.75rem;
  font-weight: 600;
  line-height: 1.5;
}

.fuel-table tbody tr {
  border-bottom: 1px solid var(--fuel-border-color);
  transition: background-color 0.2s ease-in-out;
}

.fuel-table tbody tr:hover {
  background-color: #f9fafb;
}

.fuel-table td {
  padding: 0.75rem 1.5rem;
  font-size: 0.875rem;
  color: var(--fuel-text-primary);
}

/* Media Queries for Responsiveness */
@media (min-width: 768px) {
  /* .fuel-container {
    padding: 2.5rem;
  } */
  /* .fuel-card {
    border-radius: 1rem;
  } */
  .fuel-header {
    padding: 0.5rem;
  }
  .fuel-heading {
    font-size: 2rem;
  }
  .fuel-content {
    padding: 1rem;
  }
  .fuel-select-wrapper {
    max-width: 24rem;
  }
}
.check_average_btn {
  padding: 6px 12px;
  /* background: linear-gradient(135deg, #0d5787 0%, #69aed2 100%); */
  background: #6b7280;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.2s ease-in-out;
}

.fuel-popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px; /* extra padding for mobile */
  z-index: 999;
}

.fuel-popup-card {
  background: #fff;
  padding: 20px;
  border-radius: 12px;
  width: 90%;
  max-width: 700px;
  max-height: 85vh;
  overflow-y: auto;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.2);
}

.fuel-popup-card h3 {
  margin-bottom: 12px;
  text-align: center;
  font-size: 1.2rem;
}

/* Make table scrollable on small screens */
.fuel-table-wrapper {
  width: 100%;
  overflow-x: auto;
}

.fuel-average-table {
  width: 100%;
  min-width: 500px; /* prevents table from collapsing too much */
  border-collapse: collapse;
}

.fuel-average-table th,
.fuel-average-table td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: center;
  font-size: 0.9rem;
}

/* Close button */
.fuel-popup-close-btn {
  margin-top: 16px;
  padding: 10px 18px;
  background: #ff6666;
  border: none;
  border-radius: 6px;
  color: #fff;
  font-weight: bold;
  cursor: pointer;
  display: block;
  margin-left: auto;
  margin-right: auto;
}

.fuel-popup-close-btn:hover {
  background: #e60000;
}

/* Responsive breakpoints */
@media (max-width: 768px) {
  .fuel-popup-card {
    padding: 15px;
  }

  .fuel-popup-card h3 {
    font-size: 1rem;
  }

  .fuel-average-table th,
  .fuel-average-table td {
    padding: 6px;
    font-size: 0.8rem;
  }
}

@media (max-width: 480px) {
  .fuel-popup-card {
    width: 100%;
    border-radius: 8px;
    padding: 12px;
  }

  .fuel-average-table {
    min-width: 400px; /* still scrollable horizontally */
  }

  .fuel-popup-close-btn {
    width: 100%;
    font-size: 0.9rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Pages/Machine/Fuel.css"],"names":[],"mappings":"AAAA;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,gCAAgC;EAChC,4BAA4B;EAC5B,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,8CAA8C;EAC9C,+BAA+B;EAC/B,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE;sBACoB;EACpB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,4BAA4B;EAC5B;yCACuC;EACvC,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,6CAA6C;EAC7C,6DAA6D;EAC7D,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,4BAA4B;EAC5B,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,oCAAoC;EACpC,4CAA4C;AAC9C;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,QAAQ;EACR,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,QAAQ;EACR,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,QAAQ;EACR,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE;;IAEE,uCAAuC;EACzC;EACA;IACE,2CAA2C;EAC7C;AACF;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE;;0BAEwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;;;GAGG;;AAEH;;;;;;;;;;;;GAYG;;AAEH;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,iCAAiC;EACjC,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,0CAA0C;EAC1C,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,+BAA+B;EAC/B,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,6CAA6C;EAC7C,gCAAgC;EAChC,wCAAwC;AAC1C;;AAEA;;EAEE,kBAAkB;EAClB,iBAAiB;EACjB,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,2CAA2C;EAC3C,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,8CAA8C;EAC9C,iDAAiD;AACnD;;AAEA;EACE,uBAAuB;EACvB,iCAAiC;EACjC,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iDAAiD;EACjD,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA,qCAAqC;AACrC;EACE;;KAEG;EACH;;KAEG;EACH;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;AACF;AACA;EACE,iBAAiB;EACjB,mEAAmE;EACnE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa,EAAE,6BAA6B;EAC5C,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,2CAA2C;AAC3C;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB,EAAE,4CAA4C;EAC9D,yBAAyB;AAC3B;;AAEA;;EAEE,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,YAAY;IACZ,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,WAAW;IACX,kBAAkB;IAClB,aAAa;EACf;;EAEA;IACE,gBAAgB,EAAE,kCAAkC;EACtD;;EAEA;IACE,WAAW;IACX,iBAAiB;EACnB;AACF","sourcesContent":[":root {\n  --fuel-primary-color: #2563eb;\n  --fuel-secondary-color: #1e40af;\n  --fuel-background-light: #f9fafb;\n  --fuel-text-primary: #1f2937;\n  --fuel-text-secondary: #4b5563;\n  --fuel-border-color: #e5e7eb;\n}\n\nbody {\n  margin: 0;\n  font-family: sans-serif;\n  background-color: var(--fuel-background-light);\n  color: var(--fuel-text-primary);\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.fuel-container {\n  /* padding: 2.5rem;\n  min-height: 100vh; */\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.fuel-card {\n  /* max-width: 90rem; */\n  width: 100%;\n  /* background-color: #fff; */\n  /* box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1),\n    0 4px 6px -2px rgba(0, 0, 0, 0.05); */\n  /* border-radius: 1rem; */\n  overflow: hidden;\n}\n\n.fuel-header {\n  position: relative;\n  /* background: var(--land-gradient-purple); */\n  background: linear-gradient(135deg, #20948b 100%, #c4dfe6 0%);\n  color: white;\n  padding: 1rem 1rem;\n  overflow: hidden;\n  margin-bottom: 1.5rem;\n  border-radius: 0 0 0rem 0rem;\n  box-shadow: var(--land-shadow-lg);\n}\n\n.fuel-header-bg {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  overflow: hidden;\n}\n\n.fuel-animated-shape {\n  position: absolute;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.1);\n  animation: landFloat 6s ease-in-out infinite;\n}\n\n.fuel-shape-1 {\n  width: 100px;\n  height: 100px;\n  top: 20%;\n  left: 10%;\n  animation-delay: 0s;\n}\n\n.fuel-shape-2 {\n  width: 150px;\n  height: 150px;\n  top: 60%;\n  right: 15%;\n  animation-delay: 2s;\n}\n\n.fuel-shape-3 {\n  width: 80px;\n  height: 80px;\n  bottom: 30%;\n  left: 20%;\n  animation-delay: 4s;\n}\n\n.fuel-shape-4 {\n  width: 120px;\n  height: 120px;\n  top: 10%;\n  right: 30%;\n  animation-delay: 1s;\n}\n\n@keyframes landFloat {\n  0%,\n  100% {\n    transform: translateY(0px) rotate(0deg);\n  }\n  50% {\n    transform: translateY(-20px) rotate(180deg);\n  }\n}\n\n.fuel-header-content {\n  max-width: 800px;\n  margin: 0 auto;\n  text-align: center;\n}\n\n.fuel-title {\n  /* font-size: 2rem;\n  font-weight: 700;\n  margin-bottom: 0.5rem; */\n  font-size: 1.5rem;\n  font-weight: 700;\n  margin-bottom: 0.5rem;\n  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  text-align: center;\n}\n\n.fuel-subtitle {\n  font-size: 1.125rem;\n  opacity: 0.9;\n  font-weight: 300;\n}\n\n/* .fuel-header {\n  color: #000000;\n  border-radius: 1rem 1rem 0 0;\n} */\n\n/* .fuel-heading {\n  font-size: 2rem;\n  font-weight: 800;\n  text-align: center;\n  margin-bottom: 0.25rem;\n}\n\n.fuel-description {\n  text-align: center;\n  font-size: 1rem;\n  font-weight: 300;\n  opacity: 0.9;\n} */\n\n.fuel-content {\n  padding: 2rem;\n}\n\n.fuel-select-wrapper {\n  margin-bottom: 2rem;\n  max-width: 24rem;\n  /* margin-left: auto; */\n  margin-right: auto;\n}\n\n.fuel-label {\n  display: block;\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: var(--fuel-text-secondary);\n  margin-bottom: 0.5rem;\n}\n\n.fuel-custom-select {\n  position: relative;\n}\n\n.fuel-select {\n  display: block;\n  width: 100%;\n  appearance: none;\n  background-color: #fff;\n  border: 1px solid var(--fuel-border-color);\n  border-radius: 0.5rem;\n  padding: 0.5rem 1rem;\n  padding-right: 2rem;\n  font-size: 1rem;\n  color: var(--fuel-text-primary);\n  outline: none;\n  transition: all 0.2s ease-in-out;\n}\n\n.fuel-select:focus {\n  /* border-color: var(--fuel-primary-color); */\n  border-color: rgb(196, 223, 230);\n  box-shadow: 0 0 0 2px rgb(196, 223, 230);\n}\n\n.fuel-loading,\n.fuel-no-data {\n  text-align: center;\n  padding: 2.5rem 0;\n  color: var(--fuel-text-secondary);\n  font-size: 1rem;\n}\n\n.fuel-table-responsive {\n  overflow-x: auto;\n  border-radius: 0.5rem;\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n  border: 1px solid var(--fuel-border-color);\n}\n\n.fuel-table {\n  width: 100%;\n  text-align: left;\n  white-space: nowrap;\n  border-collapse: collapse;\n}\n\n.fuel-table thead {\n  background-color: var(--fuel-background-light);\n  border-bottom: 1px solid var(--fuel-border-color);\n}\n\n.fuel-table th {\n  padding: 0.75rem 1.5rem;\n  color: var(--fuel-text-secondary);\n  text-transform: uppercase;\n  font-size: 0.75rem;\n  font-weight: 600;\n  line-height: 1.5;\n}\n\n.fuel-table tbody tr {\n  border-bottom: 1px solid var(--fuel-border-color);\n  transition: background-color 0.2s ease-in-out;\n}\n\n.fuel-table tbody tr:hover {\n  background-color: #f9fafb;\n}\n\n.fuel-table td {\n  padding: 0.75rem 1.5rem;\n  font-size: 0.875rem;\n  color: var(--fuel-text-primary);\n}\n\n/* Media Queries for Responsiveness */\n@media (min-width: 768px) {\n  /* .fuel-container {\n    padding: 2.5rem;\n  } */\n  /* .fuel-card {\n    border-radius: 1rem;\n  } */\n  .fuel-header {\n    padding: 0.5rem;\n  }\n  .fuel-heading {\n    font-size: 2rem;\n  }\n  .fuel-content {\n    padding: 1rem;\n  }\n  .fuel-select-wrapper {\n    max-width: 24rem;\n  }\n}\n.check_average_btn {\n  padding: 6px 12px;\n  /* background: linear-gradient(135deg, #0d5787 0%, #69aed2 100%); */\n  background: #6b7280;\n  color: #fff;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: background-color 0.2s ease-in-out;\n}\n\n.fuel-popup-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.6);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 10px; /* extra padding for mobile */\n  z-index: 999;\n}\n\n.fuel-popup-card {\n  background: #fff;\n  padding: 20px;\n  border-radius: 12px;\n  width: 90%;\n  max-width: 700px;\n  max-height: 85vh;\n  overflow-y: auto;\n  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.2);\n}\n\n.fuel-popup-card h3 {\n  margin-bottom: 12px;\n  text-align: center;\n  font-size: 1.2rem;\n}\n\n/* Make table scrollable on small screens */\n.fuel-table-wrapper {\n  width: 100%;\n  overflow-x: auto;\n}\n\n.fuel-average-table {\n  width: 100%;\n  min-width: 500px; /* prevents table from collapsing too much */\n  border-collapse: collapse;\n}\n\n.fuel-average-table th,\n.fuel-average-table td {\n  border: 1px solid #ddd;\n  padding: 8px;\n  text-align: center;\n  font-size: 0.9rem;\n}\n\n/* Close button */\n.fuel-popup-close-btn {\n  margin-top: 16px;\n  padding: 10px 18px;\n  background: #ff6666;\n  border: none;\n  border-radius: 6px;\n  color: #fff;\n  font-weight: bold;\n  cursor: pointer;\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.fuel-popup-close-btn:hover {\n  background: #e60000;\n}\n\n/* Responsive breakpoints */\n@media (max-width: 768px) {\n  .fuel-popup-card {\n    padding: 15px;\n  }\n\n  .fuel-popup-card h3 {\n    font-size: 1rem;\n  }\n\n  .fuel-average-table th,\n  .fuel-average-table td {\n    padding: 6px;\n    font-size: 0.8rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .fuel-popup-card {\n    width: 100%;\n    border-radius: 8px;\n    padding: 12px;\n  }\n\n  .fuel-average-table {\n    min-width: 400px; /* still scrollable horizontally */\n  }\n\n  .fuel-popup-close-btn {\n    width: 100%;\n    font-size: 0.9rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
